<template>
    <a-modal :visible="visible"
             :footer="false"
             :hide-title="true"
             :mask-closable="false"
             width="854px">
        <div class="up-content">
            <div class="titleBox">
                <span class="titleText">{{ $t('withdraw.withdraw') }}</span>
                <icon-close @click="close" size="22"/>
            </div>
            <div class="container">
                <div class="_left">
                    <div class="label">
                        <p>{{ $t('withdraw.withdraw_currency') }}</p>
                        <a-trigger position="bottom" v-model:popup-visible="coinShow" :popup-translate="[0, 10]">
                            <div class="select-button">
                                <span class="defalut" v-if="!current">{{ $t('withdraw.select_currency') }}</span>
                                <div class="coin" v-else>
                                    <img :src="current['icon']" alt="">
                                    <span>{{current['symbol']}}</span>
                                </div>
                                <icon-caret-down/>
                            </div>
                            <template #content>
                                <div class="coin-list">
                                    <div class="top">
                                        <a-input class="search" v-model="search" :placeholder="$t('withdraw.search_currency')">
                                            <template #prefix>
                                                <icon-search/>
                                            </template>
                                        </a-input>
                                    </div>
                                    <a-scrollbar class="bottom">
                                        <div class="cell" v-for="(item,index) in (search !== '' ? coin.filter(item=>item.symbol!==null&&item.symbol.toLowerCase().includes(search.toLowerCase())):coin.filter(item=>item.symbol !== null))" :key="'coin'+item.id" @click="itemclick(item)">
                                            <img :src="item['icon']" alt="">
                                            <span>{{item['symbol']}}</span>
                                        </div>
                                    </a-scrollbar>
                                </div>
                            </template>
                        </a-trigger>
                        <div class="hot-coin">
                            <div class="item" v-for="(item,index) in coin.filter(item=>item.symbol !== null).slice(0,4)" :key="'q'+item.id" @click="itemclick(item)">
                                <img :src="item['icon']" alt="">
                                <span>{{item['symbol']}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="label">
                        <p>{{ $t('withdraw.withdraw_network') }}</p>
                        <a-trigger position="bottom" v-model:popup-visible="netShow" :popup-translate="[0, 10]">
                            <div class="select-button">
                                <span class="defalut">{{ net === false ? $t('withdraw.select_network') : netlist[net]['symbol'] }}</span>
                                <icon-caret-down/>
                            </div>
                            <template #content>
                                <div class="network-list">
                                    <a-scrollbar class="scroll">
                                        <div class="cell" v-for="(item,index) in netlist" :key="'net'+item.id" @click="net=index;netShow=false">
                                            <span>{{item['symbol']}}</span>
                                        </div>
                                    </a-scrollbar>
                                </div>
                            </template>
                        </a-trigger>
                    </div>
                    <div class="label">
                        <p>{{ $t('withdraw.withdraw_address') }}</p>
                        <a-input class="label-input" v-model="token" :placeholder="$t('withdraw.enter_address')">
                            <template #suffix>
                                <svg width="24" height="24" viewBox="0 0 24 24"
                                     fill="none" xmlns="http://www.w3.org/2000/svg"
                                     class="cursor">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M6.7998 4.7998C5.69524 4.7998 4.7998 5.69524 4.7998 6.79981V7.2002H6C6.66274 7.2002 7.2 7.73745 7.2 8.4002C7.2 9.06294 6.66274 9.6002 6 9.6002H4.7998V10.8H6C6.66274 10.8 7.2 11.3373 7.2 12C7.2 12.6627 6.66274 13.2 6 13.2H4.7998V14.4004H6C6.66274 14.4004 7.2 14.9376 7.2 15.6004C7.2 16.2631 6.66274 16.8004 6 16.8004H4.7998V17.1998C4.7998 18.3044 5.69524 19.1998 6.79981 19.1998H17.1998C18.3044 19.1998 19.1998 18.3044 19.1998 17.1998V6.7998C19.1998 5.69524 18.3044 4.7998 17.1998 4.7998H6.7998Z"
                                          fill="var(--content-primary)">
                                    </path>
                                    <path d="M11 10H13" stroke="#161A1E" stroke-width="2" stroke-linecap="round"></path>
                                    <path d="M11 14H15.5" stroke="#161A1E" stroke-width="2"
                                          stroke-linecap="round"></path>
                                </svg>
                            </template>
                        </a-input>
                    </div>
                    <div class="label">
                        <p>{{ $t('withdraw.withdraw_amount') }}</p>
                        <a-input class="label-input" v-model="amount" :placeholder="current ? $t('withdraw.enter_amount') : $t('withdraw.insufficient_balance')">
                            <template #suffix>
                                <span class="color-primary cursor" @click="amount = current['balance']">{{ $t('withdraw.withdraw_all') }}</span>
                            </template>
                        </a-input>
                        <div class="mt-20" style="width: 100%" v-if="token !== '' && amount !== '' && current && net !== false">
                            <p>{{ getTranslation('withdraw.identity_verification', 'Identity Verification') }}</p>
                            <a-input class="label-input" v-model="verifyCode" :placeholder="getVerificationPlaceholder()">
                                <template #suffix>
                                    <span class="color-primary cursor" @click="sendCode">{{ getCodeButtonText() }}</span>
                                </template>
                            </a-input>
                        </div>
                        <div class="overage">
                            <p>
                                {{ $t('withdraw.available') }}
                                <span>{{current ? $util.float(current['balance']):'--'}} {{current['symbol']}}</span>
                            </p>
                            <p>
                                {{ $t('withdraw.fee') }}
                                <span>{{hasValidQuote() ? withdrawQuote.fee_amount:'--'}} {{current['symbol']}}</span>
                            </p>
                            <p>
                                {{ $t('withdraw.receive_amount') }}
                                <span>{{hasValidQuote() ? withdrawQuote.receive_amount:'--'}} {{current['symbol']}}</span>
                            </p>
                            <p v-if="hasValidQuote()">
                                {{ feeModeText() }}
                            </p>
                        </div>
                    </div>
                    <a-button class="confirm" @click="submit" :loading="loading" :disabled="token === '' || !hasValidQuote() || !current || net === false || verifyCode === ''">
                        {{ $t('withdraw.withdraw') }}
                    </a-button>
                </div>
                <div class="_right">
                    <div class="card">
                        <div class="_cell">
                            <span>{{ $t('withdraw.min_withdraw') }}</span>
                            <span>{{current ? $util.float(current['with_min']):'--'}} {{current['symbol']}}</span>
                        </div>
                        <div class="_cell">
                            <span>{{ $t('withdraw.max_withdraw') }}</span>
                            <span>{{current ? $util.float(current['with_max']):'--'}} {{current['symbol']}}</span>
                        </div>
<!--                        <div class="_cell">-->
<!--                            <span>单日提现限额</span>-->
<!--                            <span>{{current ? $util.float(current['with_max']):'&#45;&#45;'}} {{current['symbol']}}</span>-->
<!--                        </div>-->
<!--                        <div class="_cell">-->
<!--                            <span>24小时提现限额</span>-->
<!--                            <span>8,698.2994 BCH</span>-->
<!--                        </div>-->
                    </div>
                    <div class="tips">
                        <p>{{ $t('withdraw.withdraw_reminder') }}</p>
                        <span>{{ $t('withdraw.security_policy_reminder') }}</span>
                        <span>{{ $t('withdraw.relogin_wait_reminder') }}</span>
                    </div>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import commonApi from '@/common/api/common';
import userApi from '@/common/api/user';

import {mapState,mapGetters} from "vuex";

export default {
    name: 'withdrawTrgget',
    props: {
        visible: {
            default: false,
            type: Boolean
        }
    },
    data() {
        return {
            rechargeNetwork: '',
            coin: [],
            netlist: [],
            net: false,
            current: false,
            token: "",
            amount: "",
            content: "",
            title: "",
            type: "",
            search:"",
            coinShow:false,
            netShow:false,
            loading : false,
            withdrawQuote: null,
            quoteInput: null,
            quoteRequestId: 0,
            quoteTimer: null,

            verifyCode:"",
            codeType:""
        }
    },
    computed:{
        ...mapGetters(['isLogin','userId'])
    },
    watch: {
        amount() {
            this.scheduleWithdrawQuote();
        }
    },
    mounted() {
        console.log("with coin");
        this.getCurrency();
    },
    methods: {
        // 翻译辅助方法
        getTranslation(key, fallback) {
            const translated = this.$t(key);
            // 如果翻译键不存在，$t会返回键名本身
            return translated === key ? fallback : translated;
        },
        getVerificationPlaceholder() {
            if (this.codeType === '') {
                return this.getTranslation('withdraw.get_verification_code', 'Get Verification Code');
            } else if (this.codeType === 'google') {
                return this.getTranslation('withdraw.enter_google_code', 'Enter Google Authenticator Code');
            } else if (this.codeType === 'email') {
                return this.getTranslation('withdraw.enter_email_code', 'Enter Email Verification Code');
            } else {
                return this.getTranslation('withdraw.enter_phone_code', 'Enter Phone Verification Code');
            }
        },
        getCodeButtonText() {
            if (this.codeType === '') {
                return this.getTranslation('withdraw.get_code', 'Get Code');
            } else {
                return this.getTranslation('withdraw.resend_code', 'Resend');
            }
        },
        submit(){
            if (!this.hasValidQuote() || this.loading) {
                return;
            }
            this.loading = true;
            commonApi.postWithdraw({
                amount: this.amount,
                network: this.netlist[this.net]['id'],
                currency_id: this.current['id'],
                address: this.token,
                code: this.verifyCode,
                type: this.codeType
            }).then(res=>{
                this.loading = false;
                if(res.code === 200){
                    this.$notification.info(this.$t('withdraw.withdraw_application_reviewing'));
                    this.token = '';
                    this.amount = '';
                    this.verifyCode = '';
                    this.codeType = '';
                    this.withdrawQuote = null;
                    this.quoteInput = null;
                    this.getCurrency();
                }else{
                    this.$notification.info(res.message);
                }
            }).catch((e)=>{
                this.loading = false;
                this.$notification.info(e);
            })
        },
        sendCode(){
            if (!this.hasValidQuote()) {
                this.$notification.info(this.getTranslation('withdraw.amount_limit_error', 'Withdrawal amount does not meet the limit'));
                return false;
            }
            userApi.getUniCode().then(res=>{
               if(res.code === 200){
                   this.$notification.info(this.getTranslation('withdraw.code_sent', 'Verification code sent'));
                    this.codeType = res.data.type;
               }else{
                   this.$notification.info(res.message);
               }
            });
        },
        hasValidQuote() {
            return Boolean(
                this.withdrawQuote
                && this.current
                && this.quoteInput
                && this.quoteInput.currencyId === this.current.id
                && this.quoteInput.amount === this.amount
            );
        },
        feeModeText() {
            if (!this.hasValidQuote()) return '';
            return Number(this.withdrawQuote.fee_mode) === 2
                ? `${this.$t('withdraw.percentage_fee')} (${this.withdrawQuote.fee_rate}%)`
                : this.$t('withdraw.fixed_fee');
        },
        scheduleWithdrawQuote() {
            this.withdrawQuote = null;
            this.quoteInput = null;
            if (this.quoteTimer) clearTimeout(this.quoteTimer);
            if (!this.current || !/^\d+(?:\.\d{1,10})?$/.test(String(this.amount || ''))) return;

            const requestId = ++this.quoteRequestId;
            const currencyId = this.current.id;
            const quotedAmount = this.amount;
            this.quoteTimer = setTimeout(() => {
                commonApi.getWithdrawQuote(currencyId, quotedAmount).then(res => {
                    if (requestId !== this.quoteRequestId || !this.current || this.current.id !== currencyId || this.amount !== quotedAmount) return;
                    if (res.code === 200 && res.data) {
                        this.withdrawQuote = res.data;
                        this.quoteInput = { currencyId, amount: quotedAmount };
                    }
                }).catch(() => {
                    if (requestId === this.quoteRequestId) {
                        this.withdrawQuote = null;
                        this.quoteInput = null;
                    }
                });
            }, 300);
        },
        async getCurrency() {
            try {
                // 同时获取币种列表和用户余额信息
                const [currencyRes, balanceRes] = await Promise.all([
                    commonApi.getRechargeCurrency(),  // 获取币种列表（包含is_withdraw字段）
                    commonApi.getAccountCurrency()    // 获取用户余额信息
                ]);
                
                console.log('🏦 获取币种列表原始数据:', currencyRes.data.list);
                console.log('💰 获取用户余额原始数据:', balanceRes.data);
                
                // 使用工具函数过滤可提现的币种 (is_withdraw = 1)
                const withdrawableCurrencies = this.$util.filterWithdrawableCurrencies(currencyRes.data.list);
                
                // 合并币种信息和余额信息
                this.coin = withdrawableCurrencies.map(currency => {
                    // 查找对应的余额信息
                    const balanceInfo = balanceRes.data.find(balance => 
                        balance.id === currency.id || balance.currency_id === currency.id
                    );
                    
                    console.log(`💰 处理币种 ${currency.symbol}:`, {
                        currency_data: currency,
                        balance_data: balanceInfo,
                        with_charge: currency.with_charge,
                        with_min: currency.with_min,
                        with_max: currency.with_max
                    });
                    
                    // 合并币种信息和余额信息，确保保留所有重要字段
                    return {
                        ...currency,  // 保留所有原始币种信息
                        // 添加/覆盖余额相关字段
                        balance: balanceInfo ? balanceInfo.balance || '0.00' : '0.00',
                        trade_balance: balanceInfo ? balanceInfo.trade_balance || '0.00' : '0.00',
                        lock_balance: balanceInfo ? balanceInfo.lock_balance || '0.00' : '0.00',
                        // 提现相关字段优先从 balance_data 中获取，因为它包含实时的手续费信息
                        with_charge: balanceInfo ? (balanceInfo.with_charge || '0.00') : (currency.with_charge || '0.00'),
                        with_min: balanceInfo ? (balanceInfo.with_min || currency.with_min || '0.00') : (currency.with_min || '0.00'),
                        with_max: balanceInfo ? (balanceInfo.with_max || currency.with_max || '0.00') : (currency.with_max || '0.00')
                    };
                });
                
                console.log('✅ 合并后的可提现币种:', this.coin.map(c => ({
                    symbol: c.symbol, 
                    is_withdraw: c.is_withdraw, 
                    balance: c.balance,
                    with_charge: c.with_charge,
                    with_min: c.with_min,
                    with_max: c.with_max
                })));
                
                if (this.coin.length > 0) {
                    this.current = this.coin[0];
                    console.log('🔍 当前选中币种详细信息:', {
                        symbol: this.current.symbol,
                        balance: this.current.balance,
                        with_charge: this.current.with_charge,
                        with_min: this.current.with_min,
                        with_max: this.current.with_max,
                        icon: this.current.icon,
                        all_fields: Object.keys(this.current)
                    });
                    this.getNetList(this.coin[0]['id']);
                } else {
                    console.warn('⚠️ 没有可提现的币种');
                    this.current = false;
                }
                
            } catch (error) {
                console.error('❌ 获取币种和余额信息失败:', error);
                this.coin = [];
                this.current = false;
            }
        },
        getNetList(currency_id) {
            commonApi.getNetList(currency_id).then(res => {
                this.netlist = res.data.list;
                this.net = 0;
            })
        },
        itemclick(e) {
            this.current = e;
            this.getNetList(e.id);
            this.scheduleWithdrawQuote();
            this.coinShow = false;
        },
        close() {
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
@import "withdraw";
</style>
